import React from "react";
import { downloadExcelFile, getInvoiceBulkPDF } from "../../actions/InvoiceActions";
import { Dropdown } from "react-bootstrap";
import { connect } from 'react-redux';
import {
    getInvoiceQuery,
} from './Selectors';

import { withRouter } from "react-router-dom";


 export function DownloadPdfZipButton(props) {

    function downloadZip() {
        try {
            getInvoiceBulkPDF(props.dispatch, props.invoiceSearchQuery);
        } catch (e) {
            return null;
        }
    }

    return (
        <Dropdown.Item onClick={downloadZip}>{"All PDFs"}</Dropdown.Item>
    )
}



//export function DownloadPdfZipButtonwithCurrency(props: { invoiceQueryforPDFandCSVandexcel: any }) {
//    const dispatch = useDispatch();
//    const intl = useIntl();

//    function downloadZip() {
//        try {
//            getInvoiceBulkPDF(dispatch, props.invoiceQueryforPDFandCSVandexcel);
//        } catch (e) {
//            return null;
//        }
//    }

//    return (
//        <Dropdown.Item onClick={downloadZip}>{intl.formatMessage({ id: "invoice_export.all_pdfs" })}</Dropdown.Item>
//    )
//}






